import { useLocation } from 'react-router-dom';

/**
 * Checks if the current window is embedded inside an iframe, popup opener,
 * or explicitly marked as dashboard preview via query parameter.
 */
export const isLivePreviewEmbedded = (location) => {
    if (typeof window === 'undefined') return false;
    const searchParams = new URLSearchParams(location?.search || window.location?.search || '');
    return window.self !== window.top || Boolean(window.opener) || searchParams.get('source') === 'dashboard';
};

/**
 * Checks if the given location is on the live preview route.
 */
export const isLivePreviewRoute = (location) => {
    const pathname = location?.pathname || (typeof window !== 'undefined' ? window.location?.pathname : '');
    return Boolean(pathname && pathname.startsWith('/__live_preview'));
};

/**
 * Checks if the current view is an active live preview (both on preview route and embedded).
 */
export const isLivePreview = (location) => {
    return isLivePreviewRoute(location) && isLivePreviewEmbedded(location);
};

/**
 * Custom React Hook that returns true if the current route is an active embedded live preview.
 */
export const useIsPreview = () => {
    const location = useLocation();
    return isLivePreview(location);
};
